document.addEventListener('DOMContentLoaded', () => {

  const delivery = document.querySelector('[data-kedevents-delivery]');

  if (!delivery) return;

  const min = parseInt(delivery.dataset.min, 10);
  const max = parseInt(delivery.dataset.max, 10);
  const unit = delivery.dataset.unit;

  if (isNaN(min) || isNaN(max) || !unit) return;

  const start = new Date();
  const end = new Date();

  if (unit === 'immédiat') {

    const target = delivery.querySelector('.kedevents-date');

    if (target) {
      target.textContent =
        'Téléchargement immédiat après validation de votre commande.';
    }

    return;

  }

  if (unit === 'semaines') {

    start.setDate(start.getDate() + (min * 7));
    end.setDate(end.getDate() + (max * 7));

  }

  if (unit === 'jours') {

    start.setDate(start.getDate() + min);
    end.setDate(end.getDate() + max);

  }

  const options = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  };

  const startDate = start.toLocaleDateString('fr-FR', options);
  const endDate = end.toLocaleDateString('fr-FR', options);

  const target = delivery.querySelector('.kedevents-date');

  if (target) {
    target.innerHTML =
      `Votre commande sera préparée, emballée et expédiée entre le <strong>${startDate}</strong> et le <strong>${endDate}</strong>, sous réserve de validation de votre commande et en fonction des quantités commandées et de la disponibilité des articles.`;
  }

});